<template>
  <AppView class="contest-form">
    <form @submit.prevent="submitForm">
      <div class="contest-form__row">
        <p class="contest-form__comment">
          {{ $t('contestForm.child') }}
        </p>
      </div>
      <div class="contest-form__row">
        <label class="contest-form__field"
          :class="getFieldClass(fields.childFirstName)"
        >
          <p class="contest-form__label">{{ $t('contestForm.firstName') }}</p>
          <input v-model="fields.childFirstName.value" type="text" />
        </label>
        <label class="contest-form__field"
          :class="getFieldClass(fields.childLastName)"
        >
          <p class="contest-form__label">{{ $t('contestForm.lastName') }}</p>
          <input v-model="fields.childLastName.value" type="text" />
        </label>
      </div>
      <div class="contest-form__row">
        <p class="contest-form__comment">
          {{ $t('contestForm.parent') }}
        </p>
      </div>
      <div class="contest-form__row">
        <label class="contest-form__field"
          :class="getFieldClass(fields.firstName)"
        >
          <p class="contest-form__label">{{ $t('contestForm.firstName') }}</p>
          <input v-model="fields.firstName.value" type="text" />
        </label>
        <label class="contest-form__field"
          :class="getFieldClass(fields.lastName)"
        >
          <p class="contest-form__label">{{ $t('contestForm.lastName') }}</p>
          <input v-model="fields.lastName.value" type="text" />
        </label>
      </div>
      <div class="contest-form__row">
        <label class="contest-form__field"
          :class="getFieldClass(fields.email)"
        >
          <p class="contest-form__label">{{ $t('contestForm.email') }}</p>
          <input v-model="fields.email.value" type="text" />
        </label>
        <label class="contest-form__field"
          :class="getFieldClass(fields.phone)"
        >
          <p class="contest-form__label">{{ $t('contestForm.phone') }}</p>
          <input v-model="fields.phone.value" type="text" />
        </label>
      </div>
      <div class="contest-form__row">
        <p class="contest-form__comment">{{ $t('contestForm.legals.header') }}</p>
      </div>
      <div class="contest-form__row">
        <label class="contest-form__field"
          :class="getFieldClass(fields.legal1)"
        >
          <input v-model="fields.legal1.value" type="checkbox" />
          <div class="contest-form__checkbox"></div>
          <p class="contest-form__label" v-html="$t('contestForm.legals.1')"></p>
        </label>
      </div>
      <div class="contest-form__row">
        <label class="contest-form__field"
          :class="getFieldClass(fields.legal2)"
        >
          <input v-model="fields.legal2.value" type="checkbox" />
          <div class="contest-form__checkbox"></div>
          <p class="contest-form__label" v-html="$t('contestForm.legals.2')"></p>
        </label>
      </div>
      <div class="contest-form__row">
        <label class="contest-form__field"
          :class="getFieldClass(fields.legal3)"
        >
          <input v-model="fields.legal3.value" type="checkbox" />
          <div class="contest-form__checkbox"></div>
          <p class="contest-form__label" v-html="$t('contestForm.legals.3')"></p>
        </label>
      </div>
      <div class="contest-form__row">
        <p class="contest-form__comment">{{ $t('contestForm.legals.reminder') }}</p>
      </div>
      <div class="contest-form__row">
        <label class="contest-form__field"
          :class="getFieldClass(fields.legal4)"
        >
          <input v-model="fields.legal4.value" type="checkbox" />
          <div class="contest-form__checkbox"></div>
          <p class="contest-form__label" v-html="$t('contestForm.legals.4')"></p>
        </label>
      </div>
      <div class="contest-form__row">
        <label class="contest-form__field"
          :class="getFieldClass(fields.legal5)"
        >
          <input v-model="fields.legal5.value" type="checkbox" />
          <div class="contest-form__checkbox"></div>
          <p class="contest-form__label" v-html="$t('contestForm.legals.5')"></p>
        </label>
      </div>
      <div class="contest-form__row">
        <p class="contest-form__comment" v-html="$t('contestForm.legals.info')"></p>
      </div>
      <div class="contest-form__row">
        <p class="contest-form__comment contest-form__comment--required" :class="{
          'contest-form__comment--highlighted': shouldShowErrors
        }" v-html="$t('contestForm.required')"></p>
      </div>
      <div class="contest-form__row">
        <input class="contest-form__submit button" type="submit" :value="$t('contestForm.submit')" />
      </div>
    </form>
  </AppView>
</template>

<script>
import { mapState } from 'vuex';
import AppView from '@/components/AppView.vue';
import ApiService from '@/services/ApiService.js';

const TYPE_TEXT = Symbol('TYPE_TEXT');
const TYPE_EMAIL = Symbol('TYPE_EMAIL');
const TYPE_BOOLEAN = Symbol('TYPE_BOOLEAN');

export default {
  name: 'ContestForm',

  components: {
    AppView,
  },

  data() {
    return {
      isLoading: false,
      shouldShowErrors: false,
      fields: {
        answer: {
          type: TYPE_TEXT,
          isRequired: false,
          value: '',
        },
        firstName: {
          type: TYPE_TEXT,
          isRequired: true,
          value: '',
        },
        lastName: {
          type: TYPE_TEXT,
          isRequired: true,
          value: '',
        },
        childFirstName: {
          type: TYPE_TEXT,
          isRequired: true,
          value: '',
        },
        childLastName: {
          type: TYPE_TEXT,
          isRequired: true,
          value: '',
        },
        email: {
          type: TYPE_EMAIL,
          isRequired: true,
          value: '',
        },
        phone: {
          type: TYPE_TEXT,
          isRequired: true,
          value: '',
        },
        legal1: {
          type: TYPE_BOOLEAN,
          isRequired: true,
          value: false,
        },
        legal2: {
          type: TYPE_BOOLEAN,
          isRequired: true,
          value: false,
        },
        legal3: {
          type: TYPE_BOOLEAN,
          isRequired: false,
          value: false,
        },
        legal4: {
          type: TYPE_BOOLEAN,
          isRequired: true,
          value: false,
        },
        legal5: {
          type: TYPE_BOOLEAN,
          isRequired: true,
          value: false,
        },
      },
    };
  },

  computed: {
    ...mapState({
      attachment: state => state.attachment,
    }),
  },

  methods: {
    isFieldValid({ value, type, isRequired }) {
      switch (type) {
        case TYPE_TEXT:
          return isRequired ? !!value : true;
        case TYPE_BOOLEAN:
          return isRequired ? value : true;
        case TYPE_EMAIL:
          return isRequired ? /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/
            .test(value) : !value;
        default:
          throw new TypeError(`Unsupported field type ${type}`);
      }
    },

    isFormValid(fields) {
      return fields.every(field => this.isFieldValid(field));
    },

    getFieldClass(field) {
      const { shouldShowErrors } = this;
      const { isRequired } = field;
      const isFieldValid = this.isFieldValid(field);
      const shouldHaveInvalidClass = shouldShowErrors && !isFieldValid;
      return {
        'contest-form__field--invalid': shouldHaveInvalidClass,
        'contest-form__field--required': isRequired,
      };
    },

    createFieldsData(fields) {
      const {
        legal1, legal2, legal3, legal4, legal5, ...rest
      } = Object
        .entries(fields)
        .reduce((previous, [key, { value }]) => Object.assign({}, previous, {
          [key]: value,
        }), {});
      return Object.assign({}, rest, {
        legals: [legal1, legal2, legal3, legal4, legal5],
      });
    },

    async submitForm() {
      const { fields, attachment } = this;
      const isFormValid = this.isFormValid(Object.values(fields));
      const data = this.createFieldsData(fields);
      this.shouldShowErrors = !isFormValid;
      if (!isFormValid) { return; }
      this.isLoading = true;
      await ApiService.createEntry({ data, attachment, appId: this.$t('app.id') });
      this.isLoading = false;
      this.$router.push('/contest/end');
    },
  },
};
</script>

<style lang="scss">
.contest-form {
  text-transform: none;

  form {
    padding: 50px 0;
  }

  &__list {
    padding-left: 65px;

    li {
      position: relative;
      padding-left: 70px;

      font-size: 30px;
      line-height: 1.25em;

      &:not(:first-child) {
        margin-top: 35px;
      }

      span {
        position: absolute;
        top: 0;
        left: 0;

        font-size: 60px;
        line-height: 1em;
      }
    }
  }

  &__note {
    margin-top: 35px;

    font-size: 30px;
    text-align: center;

    a {
      color: inherit;

      &:hover {
        color: #000000;
      }
    }
  }

  &__buttons {
    display: flex;
    justify-content: space-around;

    margin-top: 35px;
  }

  a {
    text-decoration: none;
    color: inherit;
    border-bottom: 1px solid #ffffff;
  }
  &__row {
    display: flex;
    padding: 0 0.625em;
    &:not(:first-child) {
      margin-top: 1.25em;
    }
  }
  &__field,
  &__comment {
    flex: 1;
    padding: 0 0.625em;
  }
  &__field {
    position: relative;
    display: block;
    input[type="text"],
    textarea {
      display: block;
      width: 100%;
      padding: 0.625em;
      color: #000000;
      font-family: inherit;
      font-size: inherit;
      background-color: rgba(255, 255, 255, 1);
      border: 1px solid transparent;
      outline: none;
    }
    input[type="checkbox"] {
      position: absolute;
      left: -9999px;
      &:checked ~ .contest-form__checkbox {
        background-color: #ffffff;
      }
    }
    ::-webkit-input-placeholder {
      color: #000000;
    }
    ::-moz-placeholder {
      color: #000000;
    }
    :-ms-input-placeholder {
      color: #000000;
    }
    :-moz-placeholder {
      color: #000000;
    }

    &--invalid {
      input[type="text"],
      textarea,
      .contest-form__checkbox {
        border-color: #ff0000;
      }
      .contest-form__label {
        color: #ff0000;
      }
      a {
        border-color: #ff0000;
      }
    }
    &--required {
      .contest-form__label::before {
        content: '*';
        vertical-align: middle;
        margin-right: 0.3125em;
        font-size: 1.5em;
        font-weight: bold;
        color: #ff0000;
      }
    }
    &:first-child {
      padding-left: 3.125em;
    }
  }
  &__comment {
    padding-left: 3.125em;
    font-weight: bold;
    text-align: justify;
    &--header {
      text-align: center;
      font-size: 30px;
    }
    &--question {
      font-family: 'Bangers', Arial, Helvetica, sans-serif;
      letter-spacing: 1px;
      text-transform: uppercase;
      margin-top: 5px;
      text-align: center;
      color: #000000;
      span {
        font-size: 30px;
        line-height: 1.25em;
      }
    }
    &--required {
      font-weight: normal;
      strong {
        vertical-align: middle;
        font-size: 1.5em;
        font-weight: bold;
        color: #ff0000;
      }
    }
    &--highlighted {
      color: #ff0000;
    }
  }
  &__checkbox {
    position: absolute;
    top: 0;
    left: 10px;
    width: 1.25em;
    height: 1.25em;
    padding: 1px;
    background-clip: content-box;
    border: 1px solid #ffffff;
    cursor: pointer;
    & ~ .contest-form__label {
      margin-bottom: 0;
    }
  }
  &__label {
    margin-bottom: 0.3125em;
    font-family: inherit;
    text-align: justify;
    color: inherit;
  }
  &__submit {
    display: block;
    min-width: 250px;
    margin: 0 auto;
    font-family: inherit;
    text-transform: uppercase;
    border: none;
    cursor: pointer;

    outline: none;

    font-family: inherit;
    padding: 20px 20px 15px;
    font-size: 30px;
    font-weight: bold;
    color: #0e76bc;
    background-color: #ffffff;

    &:hover {
      background-color: #ffff00;
    }
  }
}
</style>

